// extracted by mini-css-extract-plugin
export var dropdownIcon = "_qw-6";
export var imgContainer = "_qw-3";
export var menuIcon = "_qw-5";
export var pillWrapper = "_qw-2";
export var pillsContainer = "_qw-1";
export var subscriptionCard = "_qw-0";
export var subscriptionLogo = "_qw-4";